 

export const skinCodes = ['skin1', 'skin2', 'skin3','skin4' ]; 

// export const fontSize = ['small', 'medium', 'large' ];    

// export const fontFamily = ['Josefin', 'Roboto', 'Montserrat' ];    
// export const colors = ['blue', 'teal', 'green', 'yellow' ];  

export const fieldCd = {
    FirstName: "FNAM",
    LastName: "LNAM",
    Profession:"PROF",
    ProfSummary:"PRSU",
    Phone: "PHON",
    City: "CITY",
    Company: "COMP",
    Degree: "DGRE",   
    FreeFormat: "FRFM",
    GraduationCGPA: "GRCG",
    GraduationYear: "GRYR",
    GraduationDate: "GRDT",
    HomePhone: "HPHN",
    JobCity: "JCIT",
    JobDescription: "JDES",
    JobEndDate: "EDDT",
    JobStartDate: "JSTD",
    JobState: "JSTA",
    JobTitle: "JTIT",
    
    Location: "LOCN",
    SchoolCity: "SCIT",
    SchoolName: "SCHO",
    SchoolState: "SSTA",
    State: "STAT",
    Street: "STRT",
    ZipCode: "ZIPC",
    Email: "EMAI",
    IsEmailHidden: "EHID",
    SchoolCountry: "SCNT",
    JobCountry: "JCNT",
    Country: "CNTY"
    
};



 